//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InstructionProtocol from "./components/instructionProtocol";
import NewProtocol from './components/newProtocol';
import Statement from './components/safeguardingStatement';
import Merchant from './components/serviceMerchant';
import { verify, sms, merchant_list, scheme_info } from '@/model/javaApi/clue_team_attach_insurance.js';
import {codeReg, nameReg, IDcardReg} from '@/utils/regular.js'
import { loginMobile } from '@/model/api/loginService.js';
import { CacheModule } from '@/utils/commonUtils';
import { store,mutations } from '@/observable/store';
import { insuranceForm } from '@/model/javaApi/detail.js'
import mixinTxrNewWeb from '@/utils/mixin/mixinTxrNewWeb'
import mixinVerify from '@/utils/mixin/mixinVerify';
import { InsurStore,InsurMutations } from './store'

export default {
    name: 'ClueTeamAttachInsurance',
    mixins:[mixinTxrNewWeb,mixinVerify],
    data() {
        return {
            projectName: '',
            phone: '',
            realPhone: '',
            applicantCode: '',
            showCountDown: false,
            count: 60,
            insureExplain: '',  // 权益说明-保障权益
            isLogin: false, // 是否登陆投保链接
            materielMap: [
                {
                    fileCategoryDesc: '用户服务协议',
                    materielList: [
                        {
                            fileCategoryDesc: '用户服务协议', 
                            fileName: '用户服务协议',
                            shortUrl: 'https://static.soyoung.com/sy-pre/33oqpfw3lc7q3-1646212200700.pdf'
                        },
                    ]
                },
                {
                    fileCategoryDesc: '隐私政策',
                    materielList: [
                        {
                            fileCategoryDesc: '隐私政策', 
                            fileName: '隐私政策',
                            shortUrl: 'https://static.soyoung.com/sy-pre/nispvk91jre-1645668600705.pdf'
                        },
                    ]
                }
            ],
            newProtocolMaterielMap: [],
            descriptions: [
            ],
            commodityName: '', //保险方案-商品名称
            plan:'',
            merchantMap: {institutionName: ''},
            name: '',
            idCard: '',
            schemeCode: '', //方案code
            merchantList: [], //机构列表
            schemeInfo: [], //服务说明
            insuranceFormData: {},  //填单页面信息
            originalPrice: '',    //原价(划线价)
            urlId: '',   	//链接id
            salePrice: '',   //售价（核保定价）
        }
    },
     components: {
        InstructionProtocol,
        NewProtocol,
        Statement,
        Merchant
    },
    computed: {
        merchant() {
            return this.merchantMap.institutionName;
        },
        channelCommodityCode(){
            return this.$route.query.channelCommodityCode
        },
        // verify接口 urlParams
        verifyUrlParams() {
            return {
                compressionCode: this.$route.query.compressionCode,
                categoryCode: this.$route.query.categoryCode,
                level: this.$route.query.level,
            };
        },
        // uid
        uid(){
            return store.uid
        }
    },
    created() {
        // 身份验证
        verify(this.verifyUrlParams).then(res => {
            if (res) {
                if (res.urlEnable === 0) {
                    //已经投保过了,需跳到重复投保页面
                    this.$router.push({
                        path: "/clueTeamAttachInsuranceRepeatResult",
                    });
                    return;
                }
                this.projectName = res.projectName;
                this.phone = res.phone;
                this.realPhone = res.realPhone;
                this.insureExplain = res.insureExplain;
                this.commodityName = res.commodityName;
                this.schemeCode = res.schemeCode;
                this.originalPrice = res.originalPrice;
                this.urlId = res.urlId;
                this.salePrice = res.salePrice;
                // 将渠道商品code放在地址栏
                this.$router.push({
                    path: "/clueTeamAttachInsurance",
                    query:{
                       ...this.$route.query,
                       channelCommodityCode: res.channelCommodityCode
                    }
                }).catch(() => {});
                // 判断用户是否已登陆
                const userInfo = CacheModule.get('userInfo');
                if (userInfo) {
                    if (this.uid != 0 && (this.$route.query.ticket || res.realPhone === userInfo.login_real_phone)) {
                        // 信息完善页面添加埋点
                        this.STATISTICS_CONFIG.insur_insurinfoinputpage_page();
                        this.isLogin = true;
                        // 服务机构，姓名、身份证号赋值
                        this.merchantMap = InsurStore.merchantMap;
                        this.name = InsurStore.name;
                        this.idCard = InsurStore.idCard;
                        // 登陆状态下查询投保须知 | 保险条款 | 服务协议
                        this.getMaterielMap();
                    } else {
                        // 登陆页面添加埋点
                        this.STATISTICS_CONFIG.insur_proinfo_page();
                        // 清除用户信息
                        CacheModule.remove('userInfo')
                        this.isLogin = false;
                    }
                } else {
                    // 登陆页面添加埋点
                    this.STATISTICS_CONFIG.insur_proinfo_page();
                    this.isLogin = false;
                    // 验证码赋值
                    this.applicantCode = InsurStore.applicantCode;
                }
                // 预览阅读协议确认并同意弹窗上的协议之后，不关闭弹窗
                if (InsurStore.newProtocolModalShow) {
                    this.descriptions = this.getDescriptions();
                    this.$refs.newProtocol.modeShow=true;
                }
            }
        })
        .catch(err => {
            this.$toast(err.msg);
        })
    },
    mounted(){
        this.$nextTick(()=>{
            // 回溯视频
            this.postTX(this.channelCommodityCode)
        })
    },
    methods: {
        // 填写验证码
        codeBlur() {
            if (this.applicantCode) {
                this.STATISTICS_CONFIG.insur_proinfo_code_click();
            }
        },
        // 姓名填写
        nameBlur() {
            if (this.name) {
                this.STATISTICS_CONFIG.insur_insurinfoinput_insuredname_click();
            }
        },
        //身份证填写
        idCardBlur() {
            if (this.idCard) {
               this.STATISTICS_CONFIG.insur_insurinfoinput_insuredidentity_click();
            }
        },
        //验证码倒计时
        getCodeTime(){
            const TIME_COUNT = 60;
            if (!this.timer) {
            this.count = TIME_COUNT;
            this.showCountDown = true;
            this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                } else {
                this.showCountDown = false;
                clearInterval(this.timer);
                this.timer = null;
                }
            }, 1000)
            }
        },
        // 获取验证码
        getCode() {
            this.STATISTICS_CONFIG.insur_proinfo_getcode_click()
            this.getCodeTime();
            sms(this.$route.query.compressionCode).then(res => {
                //  console.log('验证码获取成功',res)
            }).catch(err=>{
                //console.log('验证码失败')
                 this.$toast(err.msg);
            }).finally(()=>{
            });
        },
        // 阅读并同意协议弹窗的descriptions
        getDescriptions() {
            if (this.isLogin) {
                return [
                    { label: '保险方案',value: this.commodityName},
                    { label: '投保人',value: this.name},
                    { label: '被保人',value: this.name},
                ];
            } else {
                return [
                    { label: '医美服务',value: this.projectName},
                    { label: '手机号码',value: this.phone},
                ];
            }
        },
        // 获取 投保须知 | 保险条款 | 服务协议， 填单页面信息
        getMaterielMap() {
            const params = {
                channelCommodityCode: this.channelCommodityCode,
                schemeCode: this.schemeCode,
            };
            // 获取填单页面信息
            insuranceForm({...params}).then(res =>{
                    this.insuranceFormData = res;
                    this.newProtocolMaterielMap = res.materielMap;
                    let elements = res.modules[0] && res.modules[0].elements;
                    if (elements) {
                        this.idCard = elements.find(element => element.elementEnums === 'BUYER_CARD_CODE').defaultValue;
                        this.name = elements.find(element => element.elementEnums === 'BUYER_NAME').defaultValue;
                    }
                }).finally(()=>{
                })
        },
        // 点击协议条款
        onTreatyClick(flag) {
            // flag用来标识 点击的是弹窗的协议or页面的协议
            InsurMutations.setNewProtocolModalShow(false);
            if (this.isLogin) {
                InsurMutations.setMerchantMap(this.merchantMap);
                InsurMutations.setName(this.name);
                InsurMutations.setIdCard(this.idCard);
            } else {
                InsurMutations.setApplicantCode(this.applicantCode);
            }
            if (flag === 'modal') {
                InsurMutations.setNewProtocolModalShow(true);  
            }
        },
        // 登陆
        onLogin() {
            // 先判断是否投保过了
            verify(this.verifyUrlParams).then(data => {
                if (data && data.urlEnable === 0) {
                    //已经投保过了,需跳到重复投保页面
                    this.$router.push({
                        path: "/clueTeamAttachInsuranceRepeatResult",
                        query:{
                            channelCommodityCode: data.channelCommodityCode
                        }
                    });
                    return;
                }
                // data.urlEnable===1就说明未投保过，触发立即去领取操作
                let codeData = {
                    phone: this.realPhone,
                    country_code: "86",
                    code:this.applicantCode,
                    "sys": "15"
                }
                loginMobile(codeData).then(data=>{
                    mutations.getsyToken(data.token);
                    mutations.getUid(data.uid);
                    this.$refs.InstructionProtocol.selectFlag=false;
                    this.isLogin = true;
                    let userInfo = {
                        login_token:data.token,
                        login_uid:data.uid,
                        login_phone:data.phone,
                        login_real_phone: this.realPhone,
                        login_insure_uid:data.insure_uid
                    }
                    CacheModule.set("userInfo",userInfo);
                    CacheModule.getUserInfo('userInfo'); 
                    this.getMaterielMap();
                    // 登陆成功之后添加信息完善页面加载埋点
                    this.STATISTICS_CONFIG.insur_insurinfoinputpage_page();
                }).catch(err=>{ 
                    this.$toast(err.message);
                        //console.log('data登录失败',err)
                });
            }).catch(err => {
                this.$toast(err.msg);
            });
        },
        // 立即领取
         onReceive(){
            this.STATISTICS_CONFIG.insur_proinfo_submit1_click();
            this.descriptions = this.getDescriptions();
            // 判断验证码是否位纯数字
            this.applicantCode = this.applicantCode.trim();
            let codeTest = codeReg.test(this.applicantCode)
            if(!codeTest){
                this.$toast("请您填写正确的验证码");
                return;
            }else {
                this.$refs.InstructionProtocol.checkSelectFlag().then(checked => {
                // 判断我已阅读并同意前的按钮是否勾选
                 if(checked) {
                   this.onLogin();
                 }else{
                  this.$refs.newProtocol.modeShow=true
                    // console.log('请认真阅读并勾选条款须知')
                }
            });
         }
        },
        // 预览客户告知书
        onShowNotification(){
            // 调用缓存填写验证码的方法
            this.onTreatyClick();
            // 预览
            const shortUrl = 'https://mfinsuranceapi.soyoung.com/base/file/preview/FJ202103090003.pdf';
            if(shortUrl){
                const url = `${encodeURIComponent(
                    shortUrl
                )}`;
                this.$router.push({
                    path: "/webpdf",
                    query: {
                        file: url
                    },
                    flag: "postdisable",
                });
            }else{
                this.$toast("未获取到pdf地址");
            }
        },
        // 获取选中的机构
        getSeletedMerchant(selected) {
            this.merchantMap = selected;
        },
        // 格式化提交element数据
        onFormatElement(elementEnums) {
            let ele;
            if (this.insuranceFormData.modules && this.insuranceFormData.modules[0] 
             && this.insuranceFormData.modules[0].elements) {
                ele = this.insuranceFormData.modules[0].elements
                .find(element => element.elementEnums === elementEnums);
            }
            let submitElement = {
                elementEnums,
                value: elementEnums === 'BUYER_CARD_CODE' ? this.idCard : this.name,
            };
            if (ele) {
                submitElement.isCount = ele.isCount;
                submitElement.serviceCode = ele.elementCode;
                submitElement.serviceName = ele.elementName;
            }
            return submitElement;
        },
        // 立即投保
        onInsure() {
            this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click();
            this.descriptions = this.getDescriptions();
            if (!this.merchant) {
                this.$toast('请选择您的服务机构');
            } else if (!this.name.trim() || !nameReg.test(this.name)) {
                this.$toast('请填写正确的姓名');
            } else if (!this.idCard.trim() || ( !(new RegExp("[*]").test(this.idCard)) && !IDcardReg(this.idCard.trim()))) {
                this.$toast('请填写正确的身份证号')
            }
             else {
                this.$refs.InstructionProtocol.checkSelectFlag().then(checked => {
                // 判断我已阅读并同意前的按钮是否勾选
                 if(checked) {
                    // 先检查是否投保过了
                    verify(this.verifyUrlParams).then(data => {
                        if (data) {
                            if (data.urlEnable === 0) {
                                //已经投保过了,需跳到重复投保页面
                                this.$router.push({
                                    path: "/clueTeamAttachInsuranceRepeatResult",
                                    query:{
                                        channelCommodityCode: data.channelCommodityCode
                                    }
                                });
                                return;
                            }
                            // data.urlEnable === 1就说明未投保过，开始核保-下单操作
                            // 核保
                            let submitCardCodeElement = this.onFormatElement('BUYER_CARD_CODE');
                            let submitNameElement = this.onFormatElement('BUYER_NAME');
                            
                            const submitData = {
                                elements: [],
                                channelCommodityCode:this.channelCommodityCode,
                                commodityPrice: this.salePrice,
                                hospitalId: this.merchantMap.hospitalId,
                                isFollow: this.insuranceFormData.isFollow,
                                originalPrice: this.originalPrice,
                                price: 0,
                                schemeCode: this.schemeCode,
                                urlId: this.urlId,
                                traceId:store.TXoption.bizKey, // 回溯信息
                            };
                            submitData.elements.push(submitCardCodeElement, submitNameElement);
                            this.verification(submitData,true).then(res=>{
                                // 创建订单
                                this.mixinCreatAnOrder(()=>{
                                    //投保操作成功
                                    this.$router.push({
                                        path: "/clueTeamAttachInsuranceSuccess",
                                        query: {
                                            channelCommodityCode: this.channelCommodityCode
                                        }
                                    });
                                })
                            }).catch(res =>{
                            });
                        }
                    }).catch(err => {
                        this.$toast(err.msg);
                    });
                 }else{
                 //  请认真阅读并勾选条款须知
                  this.$refs.newProtocol.modeShow=true
                }
            });
            }
        },
        // 点击已确认并同意
        submitClick() {
            this.$refs.InstructionProtocol.selectFlag=true;
            if (!this.isLogin) {
                //  登陆
                this.onLogin();
            } else {
                // 投保
                this.onInsure();
            }
        },
        // 触发保障说明弹窗
        onShowSatement() {
            scheme_info({commodityCode: this.channelCommodityCode, schemeCode: this.schemeCode}).then(data => {
                this.schemeInfo = data ? data : [];
            })
            this.$refs.statement.modeShow=true
        },
        // 触发服务机构弹窗
        onShowMerchant() {
            // 获取机构列表
            merchant_list({institutionIds: this.$route.query.institutionIds}).then(data => {
                this.merchantList = data ? data : [];
            });
            this.$refs.merchant.modeShow=true
        },
    }
}
